import { GraphQLIssueDAOFactory } from "../../lib/issue/dao/graphql/GraphQLIssueDAOFactory";
import { QuickQuoteSubmission } from "./QuickQuoteSubmission";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

const issueDAO = GraphQLIssueDAOFactory.getInstance()

export const QuickQuoteIssue = () => {
    const { issueId } = useParams<{ issueId: string; }>();

    const { data: issue, isError: issueError, isLoading: issueLoading } = useQuery({
        queryKey: ['issue', issueId], queryFn: async () => {
            return await issueDAO.getIssueById(issueId);
        }
    });

    return (
        <>
            {issueError && <div>Error fetching issue</div>}
            {issueLoading && <div>Loading...</div>}
            {issue &&
                <QuickQuoteSubmission issue={issue} />
            }
        </>
    );
}